// extracted by mini-css-extract-plugin
export var dialog = "style-module--dialog--c4598";
export var get = "style-module--get--e8814";
export var pseudo = "style-module--pseudo--42acf";
export var pseudoTriangle = "style-module--pseudo-triangle--92d36";
export var text = "style-module--text--98100";